import { createGraphqlFetcher } from '@apis/createFetcher';

type IntegrationPlatform = 'GA4' | 'shopify';

export interface Integration {
    platform: IntegrationPlatform;
    profileId: string;
    enable: boolean;
    properties: string[];
    lastEnableTime?: number;
    connectionCount?: number | null;
}

// getIntegrationConfigs 返回值
export type IntegrationConfig = {
    id: string;
} & Integration;

// CreateOrUpdateIntegration 输入值
export type UpdateIntegrationInput = { id?: string } & Integration;

const apis = {
    getIntegrationConfigs: {
        name: 'getIntegrationConfigs',
        query: `query getIntegrationConfigs($profileId:String!) {
            getIntegrationConfigs(profileId:$profileId) {
                id
                platform
                profileId
                enable
                properties
                lastEnableTime
                connectionCount
            }
        }`
    },

    createOrUpdateIntegrationConfig: {
        name: 'createOrUpdateIntegrationConfig',
        query: `mutation createOrUpdateIntegrationConfig($input:UpdateIntegrationInput!) {
            createOrUpdateIntegrationConfig(input:$input)
        }`
    },

    getIntegrationApiList: {
        name: 'getAllAPIKeys',
        query: `query getAllAPIKeys($profileId:String!){
            getAllAPIKeys(profileId:$profileId) {
                id
                profileId
                name
                createTime
                updateTime
                createBy
                status
                secretAsterisk
            }
        }`
    },

    createAPIKey: {
        name: 'createAPIKey',
        query: `mutation createAPIKey($input: APIKeyInput!){
            createAPIKey(input:$input)
        }`
    },

    deleteAPIKey: {
        name: 'deleteAPIKey',
        query: `mutation deleteAPIKey($id: ID!){
            deleteAPIKey(id:$id)
        }`
    },

    firstGuideProfile: {
        name: 'getFirstGuideByProfileId',
        query: `query getFirstGuideByProfileId($profileId:String!){
            getFirstGuideByProfileId(profileId:$profileId) {
                status guideKey
            }
        }`
    },

    updateFirstGuideProfile: {
        name: 'updateFirstGuideByProfileId',
        query: `mutation updateFirstGuideByProfileId($input:UpdateFirstGuideInput!){
            updateFirstGuideByProfileId(input:$input)
        }`
    },

    // 获取shopify列表
    getConnectionList: {
        name: 'getConnectionList',
        query: `query getConnectionList($profileId: String!, $platform: IntegrationPlatformEnum!) {
           getConnectionList(profileId: $profileId, platform: $platform) {
                id
                name
                createTime
                creator
           }
        }`
    },
    // 创建shopify connection
    createIntegrationConnection: {
        name: 'createIntegrationConnection',
        query: `mutation createIntegrationConnection($profileId: String!, $platform: IntegrationPlatformEnum!, $config: JSON){
            createIntegrationConnection(profileId: $profileId, platform: $platform, config: $config)
        }`
    },
    // 删除shopify connection
    deleteIntegrationConnection: {
        name: 'deleteIntegrationConnection',
        query: `mutation deleteIntegrationConnection($profileId: String!, $id: ID!, $platform: IntegrationPlatformEnum!) {
            deleteIntegrationConnection(profileId: $profileId, id: $id, platform: $platform)
        }`
    },
    getConnectionById: {
        name: 'getConnectionById',
        query: `query getConnectionById($id: ID!) {
            getConnectionById(id: $id) {
                id,
                name,
                connectionConfig
            }
        }`
    },
    // 更新shopify connection
    updateIntegrationConnection: {
        name: 'updateIntegrationConnection',
        query: `mutation updateIntegrationConnection($profileId: String!, $id: ID!, $config: JSON, $platform: IntegrationPlatformEnum!) {
            updateIntegrationConnection(profileId: $profileId, id: $id,config: $config, platform: $platform)
        }`
    },
    // 校验shopify connection
    verifyConnection: {
        name: 'verifyConnection',
        query: `query verifyConnection($platform: IntegrationPlatformEnum!, $config: JSON!) {
            verifyConnection(platform: $platform, config: $config)
        }`
    },
    // 获取Campaign
    getConnectionEngageList: {
        name: 'getConnectionEngageList',
        query: `query getConnectionEngageList($connectionId: ID!){
            getConnectionEngageList(connectionId: $connectionId) {
                engageId
                engageName
                engageStatus
            }
        }`
    }
};

export default createGraphqlFetcher(apis);
